import { useCallback, useMemo, useState } from 'react';
import PaymentsPopup from '../Payments/PaymentsPopup';
import { getString } from '../../../strings';
import { StyledText } from '../../atoms/Text/StyledText';
import { StyledButton } from '../../atoms/Button/StyledButton';
import { BigLoader } from '../../atoms/Loader/StyledBigLoader';
import { updatePlaces } from '../../../logic/requests/events';
import { StyledInputsDivWrapper } from '../../atoms/StyledInputsDivWrapper/StyledInputsDivWrapper';
import { StyledInputWrapper } from '../../../styles/sharedStyles';

const UpdatePlacesPopup = ({ eventData, onClose }) => {
    const [places, setPlaces] = useState();
    const [error, setError] = useState(null);
    const [queryFinished, setQueryFinished] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const onSubmit = useCallback(() => {
        setIsLoading(true);
        updatePlaces(eventData.id, places)
            .then(
                (res) => {
                    setError(null);
                },
                (err) => {
                    setError(err);
                    console.log(err);
                }
            )
            .finally(() => {
                setQueryFinished(true);
                setIsLoading(false);
            });
    }, [eventData, places]);

    const renderContent = useMemo(
        () =>
            queryFinished ? (
                <div>
                    {error ? (
                        <>
                            <StyledText
                                hasdeclaredfontsize="20px"
                                hasdeclaredpadding={'50px 20px 20px 20px'}
                                hasdeclaredlineheight="1.4em"
                                hasdeclaredtextalign="center"
                                hasdeclaredfontcolor="#EE745C"
                                hasdeclaredfontweight="600"
                            >
                                {getString('userPanel_userPanelTournament_update_places_error')}
                            </StyledText>
                            <StyledText
                                hasdeclaredfontsize="18px"
                                hasdeclaredpadding={'20px 20px 20px 20px'}
                                hasdeclaredlineheight="1.4em"
                                hasdeclaredtextalign="center"
                            >
                                {error.data.message}
                            </StyledText>
                        </>
                    ) : (
                        <StyledText
                            hasdeclaredfontsize="18px"
                            hasdeclaredpadding={'50px 20px 20px 20px'}
                            hasdeclaredlineheight="1.4em"
                            hasdeclaredtextalign="center"
                        >
                            {getString('userPanel_userPanelTournament_update_places_success')}
                        </StyledText>
                    )}
                    <div style={{ display: 'flex', justifyContent: 'center', gap: '20px' }}>
                        <StyledButton
                            hasdeclaredfontcolor="#fff"
                            hasdeclaredbgcolor="#6d85ba"
                            hasdeclaredtextalign="center"
                            hasdeclaredcursor="pointer"
                            hasdeclaredwidth="150px"
                            hasdeclaredheight="50px"
                            hasdeclaredfontsize="20px"
                            hasdeclaredborderradius="35px"
                            hasdeclaredmargin="20px 0 0 0"
                            hasdeclaredfontweight="600"
                            whileTap={{ scale: 0.9 }}
                            whileHover={{ scale: 1.05 }}
                            hasdeclaredtexttransform="uppercase"
                            onClick={onClose}
                        >
                            {getString('all_trainer_pay_popup_zamknij')}
                        </StyledButton>
                    </div>
                </div>
            ) : isLoading ? (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <BigLoader />
                </div>
            ) : (
                <>
                    <StyledText
                        hasdeclaredfontsize="18px"
                        hasdeclaredpadding={'40px 20px 20px 20px'}
                        hasdeclaredlineheight="1.4em"
                        hasdeclaredtextalign="center"
                    >
                        {getString('userPanel_userPanelTournament_update_places_title')}{' '}
                        {eventData.max_places}
                    </StyledText>
                    <StyledInputsDivWrapper>
                        <StyledInputWrapper>
                            <input
                                type="number"
                                value={places}
                                onChange={(e) => setPlaces(+e.target.value)}
                            />
                        </StyledInputWrapper>
                    </StyledInputsDivWrapper>
                    <div style={{ display: 'flex', justifyContent: 'center', gap: '20px' }}>
                        <StyledButton
                            hasdeclaredfontcolor="#fff"
                            hasdeclaredbgcolor="#6d85ba"
                            hasdeclaredtextalign="center"
                            hasdeclaredcursor="pointer"
                            hasdeclaredwidth="150px"
                            hasdeclaredheight="50px"
                            hasdeclaredfontsize="20px"
                            hasdeclaredborderradius="35px"
                            hasdeclaredmargin="20px 0 0 0"
                            hasdeclaredfontweight="600"
                            whileTap={{ scale: 0.9 }}
                            whileHover={{ scale: 1.05 }}
                            hasdeclaredtexttransform="uppercase"
                            onClick={onSubmit}
                        >
                            {getString('userPanel_userPanelTournament_sync_registrations_confirm')}
                        </StyledButton>
                        <StyledButton
                            hasdeclaredfontcolor="#fff"
                            hasdeclaredbgcolor="#ee745c"
                            hasdeclaredtextalign="center"
                            hasdeclaredcursor="pointer"
                            hasdeclaredwidth="150px"
                            hasdeclaredheight="50px"
                            hasdeclaredfontsize="20px"
                            hasdeclaredborderradius="35px"
                            hasdeclaredmargin="20px 0 40px 0"
                            hasdeclaredfontweight="600"
                            whileTap={{ scale: 0.9 }}
                            whileHover={{ scale: 1.05 }}
                            onClick={onClose}
                        >
                            {getString('userPanel_userPanelTournament_payment_reminder_cancel')}
                        </StyledButton>
                    </div>
                </>
            ),
        [onClose, isLoading, onSubmit, error, eventData.max_places, places, queryFinished]
    );

    return <PaymentsPopup>{renderContent}</PaymentsPopup>;
};

export default UpdatePlacesPopup;
